<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { Modal, Container, Button, Text } from '@Shelly/shelly-design-system';
	import { createEventDispatcher } from 'svelte';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';

	export let showModal = false;

	const dispatch = createEventDispatcher(),
		openDocsLink =
			'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math',
		examples = [
			{
				description: $format('title_custom_expression_example_water_meter_1', {
					default: 'Water meter with 10:1 counter',
				}),
				expr: 'x/10',
				unit: 'l',
			},
			{
				description: $format('title_custom_expression_example_water_meter_2', {
					default: 'Water meter with 1:100 counter',
				}),
				expr: 'x*100',
				unit: 'l',
			},
			{
				description: $format('title_custom_expression_example_gas_meter', {
					default: 'Gas meter with 1:50 counter',
				}),
				expr: 'x*50',
				unit: 'l',
			},
		];
</script>

{#if showModal}
	<Modal
		bind:showModal
		title={$format('title_input_counter_custom_expression_example_formulas', {
			default: 'Example formulas',
		})}
		on:close={() => (showModal = false)}
	>
		<svelte:fragment slot="content">
			{#each examples as example, ind}
				<Container padding="0">
					<Text styleType="body-small">
						{example.description}: <b>{example.expr}</b>
					</Text>
					<Button
						size="m"
						class="button-styles"
						icon="fas fa-plus"
						on:click={() => {
							dispatch('insert', example);
							showModal = false;
						}}
					>
						{$format('title_input_counter_custom_expression_example_insert_btn', {
							default: 'Insert',
						})}
					</Button>
				</Container>
				{#if ind < examples.length - 1}
					<hr class="mb-l mt-l" />
				{/if}
			{/each}
		</svelte:fragment>
		<div slot="footer" class="d-flex justify-content-end">
			<Button
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
				responsiveSize={{
					sm: 'm',
				}}
				icon="fa-solid fa-arrow-up-right-from-square"
				href={openDocsLink}
				target="_blank"
			>
				{$format('title_input_counter_custom_expression_example_link_btn', {
					default: 'Javascript math expressions can be used in formulas',
				})}
			</Button>
		</div>
	</Modal>
{/if}
